/* eslint-disable */
import CharaBase from "../../common/CharaBase";

class CharaEarth extends CharaBase {
  constructor(scene) {
    super(scene);
  }

  //------------------------------------
  // Setup Mesh
  //------------------------------------
  setupMeshs() {
    this.mesh = this.scene.getNodeByID("Earth");
  }

  //------------------------------------
  // Update
  //------------------------------------
  update() {
    this.mesh.rotation.y += 0.001;
  }
}
export default CharaEarth;
